import { render, staticRenderFns } from "./travelparty.vue?vue&type=template&id=645bf91f&scoped=true"
import script from "./travelparty.vue?vue&type=script&lang=js"
export * from "./travelparty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645bf91f",
  null
  
)

export default component.exports